module.exports = __webpack_public_path__ + "assets/b1c6765b1bf6d11af999a70bb427dbf9.mp3";